// extracted by mini-css-extract-plugin
export default {"logicTabList":"LogicTabList_logicTabList__k-bF1","logicTab":"LogicTabList_logicTab__9egg-"};